module.exports = __webpack_public_path__ + "static/media/kids_40.0005ea79.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/kids/JPEG/kids_40.jpg
// module id = 5896
// module chunks = 0